import type { Query } from 'firebase/firestore'
import { limit, orderBy, query, where } from 'firebase/firestore'
import type { Deal, IntakeStatus, PartnerLeadStatus } from '../models/Deal'
import { PaginatedArrayService } from './serviceLivePaginatedArray'

export class DealService extends PaginatedArrayService<Deal> {
  BATCH_SIZE = 30

  constructor() {
    super('Deals')
  }

  public listenForId(userId: string): void {
    const listenQuery = query(
      this.collection,
      where('UserId', '==', userId),
      orderBy('Created', 'desc'),
    )
    this.listen(listenQuery)
  }

  public listenForIds(userIds: string[]): void {
    const queries: Query[] = []

    for (let i = 0; i < userIds.length; i += this.BATCH_SIZE) {
      const batch = userIds.slice(i, i + this.BATCH_SIZE)
      queries.push(
        query(
          this.collection,
          where('UserId', 'in', batch),
          orderBy('Created', 'desc'),
        ),
      )
    }

    this.listenGroup(queries)
  }

  public listenForStatusIntakeDeals(intakeStatus: IntakeStatus): void {
    const pharmacyStatus = 'intakeGesprek'

    const listenQuery = query(
      this.collection,
      where('PharmacyStatus', '==', pharmacyStatus),
      where('IntakeStatus', '==', intakeStatus),
      orderBy('Created', 'desc'),
      limit(this.FETCH_LIMIT),
    )

    this.listen(listenQuery)
  }

  public listenForStatusPartnerLeadDeals(
    partnerLeadStatus: PartnerLeadStatus,
  ): void {
    const listenQuery = query(
      this.collection,
      where('PartnerLeadStatus', '==', partnerLeadStatus),
      orderBy('Created', 'desc'),
      limit(this.FETCH_LIMIT),
    )

    this.listen(listenQuery)
  }
}
